module.exports = __webpack_public_path__ + "img/mainback2.11c6f8a1.jpg";